import { Analytics } from '@cobliteam/analytics';
import type { CostsWithVehicle } from '@cobliteam/common-types';
import { CameraIdentifier } from '@cobliteam/media';
import { Dialog, Menu, Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import DataTable from '@cobliteam/ui-business/components/DataTable';
import type { Row } from '@tanstack/react-table';
import columnDef from './columnsDef';

interface CostDetailModalModuleProps {
  row: Row<CostsWithVehicle>;
}

const CostDetailModalModule = ({ row }: CostDetailModalModuleProps) => {
  const { costInfo } = row.original;

  const handleDetailsButtonClick = () => {
    Analytics.track('Costs Page Details Button Clicked');
  };

  return (
    <Dialog>
      <Dialog.Trigger asChild>
        <Menu.Item onClick={handleDetailsButtonClick} className='w-full text-center'>
          <Menu.Icon icon={<Icon name='eye' />} />
          <Menu.Label>Ver detalhes</Menu.Label>
        </Menu.Item>
      </Dialog.Trigger>

      <Dialog.Content modalSize='lg'>
        <Dialog.Header>
          <Dialog.Title>
            <Dialog.Description className='sr-only' />
            <div className='flex items-center gap-3'>
              {row.original.withDashCam && <CameraIdentifier hasCta={false} />}
              <div className='flex flex-col'>
                <Typography variant='heading-2' color='primary'>
                  {row.original.vehicle?.licensePlate}
                  {row.original.vehicle?.model.brand ? ` - ${row.original.vehicle?.model.brand}` : null}
                  {row.original.vehicle?.model.name ? ` - ${row.original.vehicle?.model.name}` : null}
                </Typography>
                <Typography variant='input-text' color='secondary'>
                  {row.original.vehicle?.groups ? row.original.vehicle?.groups[0]?.name : '--'}
                </Typography>
              </div>
            </div>
          </Dialog.Title>
          <Dialog.Close className='self-start' />
        </Dialog.Header>
        <Dialog.Body>
          <div className='mt-7'>
            <DataTable id='costs-details' estimateSize={65} manualPagination totalRows={costInfo.length} data={costInfo} columnsDef={columnDef} />
            <div className='mt-5 flex w-full items-center justify-center gap-2'>
              <Typography>Visualizando todos os {costInfo.length} eventos.</Typography>
            </div>
          </div>
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};

export default CostDetailModalModule;
